export interface WorkCenter {
  id: number;
  name: string;
  location: string;
  timezone: string;
  daily_work_hours: number;
  description?: string;
}

export interface WorkSchedule {
  id: number;
  work_center_id: number;
  day_of_week: number; // 0=Monday, 6=Sunday
  work_hours: number;
  is_working_day: boolean;
}

export interface Worker {
  id: number;
  username: string;
  email: string | null;  // Email opcional
  name: string;
  surname: string | null;  // Apellido opcional
  is_active: boolean;
  work_center_id: number;
  annual_vacation_days?: number;
  annual_flexible_hours?: number;
}

export interface WorkerVacationSummary {
  worker_id: number;
  worker_name: string;
  annual_vacation_days: number;
  annual_flexible_hours: number;
  used_vacation_days: number;
  used_flexible_hours: number;
  remaining_vacation_days: number;
  remaining_flexible_hours: number;
}

export interface VacationType {
  id: number;
  name: string;
  code: string;
  is_hourly: boolean;
  description?: string;
  is_active: boolean;
}

export enum VacationStatus {
  PENDING = 'PENDING',
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED',
  CANCELLED = 'CANCELLED'
}

export interface VacationRequest {
  id: number;
  worker_id: number;
  vacation_type_id: number;
  start_date: string;
  end_date: string;
  hours_requested?: number;
  vacation_bag_year?: number;
  status: VacationStatus;
  notes?: string;
  approved_by?: string;
}

export interface Holiday {
  id: number;
  name: string;
  date: string;
  work_center_id: number;
  is_national: boolean;
  is_recurring: boolean;
  description?: string;
  is_active: boolean;
}

export interface GanttTask {
  id: string;
  text: string;
  start_date: Date;
  end_date: Date;
  duration: number;
  type: string;
  progress: number;
  worker_id: number;
  vacation_type: string;
}